import { type Dispatch, type SetStateAction, useState } from 'react';

function useLocalStorage<T>(key: string, initialValue: T): [T, Dispatch<SetStateAction<T>>] {
  const storedValue = localStorage.getItem(key);
  const initial = storedValue ? (JSON.parse(storedValue) as T) : initialValue;

  const [value, setValue] = useState<T>(initial);

  const updateLocalStorage: Dispatch<SetStateAction<T>> = (newValue) => {
    setValue((prevValue) => {
      const valueToStore = typeof newValue === 'function' ? (newValue as (prev: T) => T)(prevValue) : newValue;
      localStorage.setItem(key, JSON.stringify(valueToStore));
      return valueToStore;
    });
  };

  return [value, updateLocalStorage];
}

export default useLocalStorage;
